/*************************************************************************************/
/*							General Settings
/*************************************************************************************/
var custom_console = false;
var console_pre = '%c🍪 ';
var console_colors = 'background: var(--foreground); color: #CB7B70';

var lifted_app_host =
  'https://taylorchipdev.com/dev/apps/bakers-dashboard/version/2.8/server/functions.php';
//var lifted_app_host = 'https://coldfox.net/apps/taylor-chip/bakers-dashboard/version/2.8/server/functions.php';

//debug.func(console_pre + arguments.callee.name, console_colors);
//debug.log(data);

/*************************************************************************************/
/*							Calendar Picker
/*************************************************************************************/

var deliveryItemID = 42085835768057;
var subscriptionItemID = 7023017361461;
var cookieCakeID = 7340556157177;
var subscriptionItemSKU = 'the-cookie-club';

var max_orders_per_day = 200;
var orders_occurrences = [];
var loaded_month;
var loaded_year;
var lookForASAPDate = true;
var scanningForASAPDate = false;
var gettingMonthData = false;

var current_transit_time = 2;

var allow_sunday = false;
var allow_monday = false;
var allow_tuesday = false;
var allow_wednesday = true;
var allow_thursday = true;
var allow_friday = false;
var allow_saturday = false;

var disabled_dates = [
  '2022-04-08',
  '2022-04-09',
  '2022-04-10',
  '2022-04-11',
  '2022-04-12',
  '2022-04-13',
  '2022-04-26',
  '2022-04-27',
  '2022-04-28',
  '2022-04-29',
  '2022-04-30',
  '2022-07-06',
  '2022-09-04',
  '2022-09-05',
  '2022-09-06',
  '2022-09-07',
  '2022-09-08',
  '2022-09-09',
  '2022-09-10',
  '2022-09-11',
  '2022-09-28',
  '2022-09-29',
  '2022-09-30',
  '2022-10-01',
  '2022-10-02',
  '2022-10-03',
  '2022-10-04',
  '2022-10-05',
  '2022-10-06',
  '2022-10-07',
  '2022-10-08',
  '2022-11-24',
  '2022-11-25',
  '2022-11-26',
  '2022-12-19',
  '2022-12-20',
  '2022-12-21',
  '2022-12-22',
  '2022-12-23',
  '2022-12-24',
  '2022-12-25',
  '2022-12-26',
  '2022-12-27',
  '2022-12-28',
  '2023-01-01',
  '2023-01-02',
  '2023-05-31',
  '2023-06-01',
  '2023-07-01',
  '2023-07-02',
  '2023-07-03',
  '2023-07-04',
  '2023-12-21',
  '2023-12-22',
  '2023-12-23',
  '2023-12-24',
  '2023-12-25',
  '2023-12-26',
  '2023-02-14',
  '2024-02-15',
  '2024-02-16',
  '2024-02-17',
  '2024-05-09',
  '2024-05-10',
  '2024-05-11',
  '2024-05-12',
  '2024-09-02',
  '2024-09-03',
  '2024-09-04',
  '2024-09-05',
  '2024-12-22',
  '2024-12-23',
  '2024-12-24',
  '2024-12-25',
  '2024-12-26',
  '2024-12-27',
  '2024-12-28',
];
var disabled_cake_dates = [
  '2022-04-08',
  '2022-04-09',
  '2022-04-10',
  '2022-04-11',
  '2022-04-12',
  '2022-04-13',
  '2022-04-14',
  '2022-04-15',
  '2022-04-16',
  '2022-04-17',
  '2022-04-18',
  '2022-04-19',
  '2022-04-20',
  '2022-04-21',
];
//var disabled_cake_dates = ["2022-04-08", "2022-04-09", "2022-04-10", "2022-04-11", "2022-04-12", "2022-04-13"];
var disabled_transit_days = [];
var maxxed_order_dates = [];

var date_order_limits = {
  '2022-04-14': { limit: 100 },
  xxxxxxxx: { limit: 100 },
};
